// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + (chunkId === 143 ? "app" : chunkId) + "." + {"73":"aac63c55db7616116336","143":"4964cefbeb4634085cc6"}[chunkId] + ".css";
};